import '../App.css';


function Terms() {

  return (
      <div className='page' style={{background:'white'}}>
        <div>
            <a style={{color:'blue', textDecorationLine:'underline', margin:'5px'}} href='#terms'>Terms</a>
            <a style={{color:'blue', textDecorationLine:'underline', margin:'5px'}} href='#privacy'>Privacy</a>
            <a style={{color:'blue', textDecorationLine:'underline', margin:'5px'}} href='#returns'>Returns</a>
            <a style={{color:'blue', textDecorationLine:'underline', margin:'5px'}} href='#shipping'>Shipping</a>
        </div>
        <h1 id="terms">Terms and Conditions</h1>
            <h2>1. Introduction</h2>
            <p>Welcome to Teejeigh LLC. These Terms and Conditions govern your use of our website (www.teejeigh.com), our downloadable applications (paperback, shared secrets), and purchases of our wallets and other products. By using our site, our applications, and our products, you agree to these terms.</p>
            
            <h2>2. Use of Website and Applications</h2>
            <p>You agree to use our website and applications lawfully and not for any prohibited purposes. We reserve the right to terminate access for misuse.</p>
            
            <h2>3. Orders and Payments</h2>
            <p>All orders are subject to availability. Prices are in USD and include any applicable taxes. We accept major credit cards and other secure payment methods. Payment must be completed before shipping.</p>
            
            <h2>4. Shipping</h2>
            <p>We offer free shipping via USPS within the United States. See our Shipping Policy for details.</p>
            
            <h2>5. Returns</h2>
            <p>Items may be returned within 7 days, with return shipping paid by the customer. See our Refund and Return Policy for details.</p>
            
            <h2>6. Limitation of Liability</h2>
            <p>Teejeigh LLC is not liable for indirect, incidental, or consequential damages arising from the use of our website, applications, or products, to the extent permitted by law.</p>
            
            <h2>7. Intellectual Property</h2>
            <p>All content on this website and on our applications, including text, videos, and images, is owned by Teejeigh LLC. Unauthorized use is prohibited.</p>
            
            <h2>8. Governing Law</h2>
            <p>These terms are governed by the laws of Michigan, United States. Any disputes will be resolved in Michigan courts.</p>
            
            <h2>9. Changes to Terms</h2>
            <p>We may update these terms at any time. Changes will be posted on this page.</p>
            
            <h2>10. Contact Us</h2>
            <p>For questions, email us at <a href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a>.</p>
            
        <h1 id="privacy">Privacy Policy</h1>
            <h2>1. Introduction</h2>
            <p>Teejeigh LLC values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website (www.teejeigh.com), our downloadable applications (paperback, shared secrets), or purchase our wallets and other products.</p>
            
            <h2>2. Information We Collect</h2>
            <p>When purchasing a product we collect:
                <ul>
                    <li>Name and address for order processing and shipping when a wallet is purchased.</li>
                    <li>Payment is provided by Stripe. We do not store your payment information.</li>
                    <li>With regard to your order, we store the Stripe provided transaction id, the items ordered, the total cost, and date.</li>
                    <li>Contact us if you would like a copy of this information regarding your order or to have this information deleted.</li>
                </ul>
            </p>

            <p>When using an application available for download we collect:
                <ul>
                    <li>Email address for correlation with Google authorized login</li>
                    <li>In order to facilitate a rich and personalized user experiece we create an id, unique name, downloaded titles array, liked titles array, and vector.</li>
                    <li>Contact us by email, <a href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a>, if you would like a copy of this information regarding your account or to have this information deleted.</li>
                    <li>Additional means of account deletion are availble through the app. Once account deletion is requested, the user account will be permanently deleted after 30 days. If the account is logged back into at anypoint after requesting an account deletion, we will assume you would like to keep the account and the previously mentioned scheduled deletion will be unscheduled. Account deletion would need to be kicked off again with a new request.</li>
                </ul>
            </p>
            
            <h2>3. How We Use Your Information</h2>
            <p>We use your information to:
                <ul>
                    <li>Process and fulfill orders.</li>
                    <li>Communicate about your order or returns.</li>
                    <li>Comply with legal obligations.</li>
                </ul>
            </p>
            
            <h2>4. Sharing Your Information</h2>
            <p>We share your information only with:
                <ul>
                    <li>USPS for shipping purposes.</li>
                    <li>Our payment processor to complete transactions.</li>
                    <li>We use Stripe for payments, analytics, and other business services. Stripe may collect personal data including via cookies and similar technologies. The personal data Stripe collects may include transactional data and identifying information about devices that connect to its services. Stripe uses this information to operate and improve the services it provides to us, including for fraud and prevention and detection, authentication, analytics related to the performance of its services, and to enhance and customize the user experience. You can learn more about Stripe and read its privacy policy at https://stripe.com/privacy.</li>
                </ul>
                We do not sell or share your data for marketing purposes.
            </p>
            
            <h2>5. Data Security</h2>
            <p>We use secure methods (e.g., HTTPS, PCI-compliant payment processors) to protect your information. However, no system is completely secure, and we cannot guarantee absolute security.</p>
            
            <h2>6. Your Rights</h2>
            <p>You may request access, correction, or deletion of your personal information by emailing <a href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a>.</p>
            
            <h2>7. Changes to This Policy</h2>
            <p>We may update this policy. Changes will be posted on this page.</p>
            
            <h2>8. Contact Us</h2>
            <p>For privacy questions, email <a href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a>.</p>
            
    <h1 id="returns">Refund and Return Policy</h1>
        <h2>1. Returns</h2>
            <p>You may return products purchased from Teejeigh LLC within 7 days of delivery. Items must be unused, in original condition, and in their original packaging.</p>
            
            <h2>2. Return Process</h2>
            <p>To initiate a return, email <a href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a> with your order number and reason for return. We will provide return instructions. Customers are responsible for return shipping costs.</p>
            
            <h2>3. Refunds</h2>
            <p>Once we receive and inspect the returned item, we will issue a refund to your original payment method within 5-7 business days. Shipping costs are non-refunded.</p>
            
            <h2>4. Non-Returnable Items</h2>
            <p>Damaged or used items are not eligible for return unless defective. Contact us for defective items.</p>
            <p>Applications downloaded are offered free of charge to users. This does not constitute a purchase and is not eligible for a return.</p>
            
            <h2>5. Contact Us</h2>
            <p>For return questions, email <a href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a>.</p>
    <h1 id="shipping">Shipping Policy</h1>
            <h2>1. Shipping Destinations</h2>
            <p>Teejeigh LLC ships products to addresses within the United States only.</p>
            
            <h2>2. Shipping Costs</h2>
            <p>We offer free shipping on all orders via USPS.</p>
            
            <h2>3. Delivery Times</h2>
            <p>Orders are typically processed within 1-2 business days. USPS delivery times vary but are generally 3-7 business days. Delays may occur due to holidays or unforeseen circumstances.</p>
            
            <h2>4. Lost or Damaged Packages</h2>
            <p>If your order is lost or damaged, email <a href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a>. We will work with USPS to resolve the issue.</p>
            
            <h2>5. Contact Us</h2>
            <p>For shipping questions, email <a href="mailto:teejeigh@teejeigh.com">teejeigh@teejeigh.com</a>.</p>
            
    </div>
  );
}

export default Terms;